import React from 'react'
import './Reason.scss'

function Reason({ icon, title, subtitle }) {
  return <div className="reason-container">
    <img src={icon}></img>
    <div className="reason_title_container">
      <div>
        <h2>{title}</h2>
      </div>
      <h3>{subtitle}</h3>
    </div>
  </div>
}

export default Reason